import { render, staticRenderFns } from "./Index_home.vue?vue&type=template&id=647b8ce7&scoped=true&"
import script from "./Index_home.vue?vue&type=script&lang=js&"
export * from "./Index_home.vue?vue&type=script&lang=js&"
import style0 from "./Index_home.vue?vue&type=style&index=0&id=647b8ce7&prod&scoped=true&lang=css&"
import style1 from "./Index_home.vue?vue&type=style&index=1&id=647b8ce7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b8ce7",
  null
  
)

export default component.exports